import script from "./AudioPlayerPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioPlayerPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AudioPlayerPopup.vue?vue&type=style&index=0&id=4720e203&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4720e203"]])

export default __exports__